<template>
	<div>
		<slot></slot>
	</div>

</template>

<script>
	export default {
		props: {
			pk:  { type: Number, required: true},
			lat: { type: Number, required: true},
			lng: { type: Number, required: true},
			icon: {type: String, required: true}
		},
		data: () => ({
			marker: null,
			info: null,

		}),
		mounted() {
			this.$parent.getMap(map => {
				this.marker = new window.google.maps.Marker({
					position: { lat: this.lat, lng: this.lng },
					icon: `./img/${this.icon}`,
					map: map
				}),
				// this.info = new window.google.maps.InfoWindow({
				// 	position: { lat: this.lat, lng: this.lng },
				// 	content: '<div class="this.lat">' + this.lat.toString() + '</div><p>sdaasd../s</p>'
				// }),
				this.marker.addListener("click", () => {
					// this.info.open(map);
					this.$emit('elementclick', this.pk)
			})

		})


			// this.marker.addListener('mouseout', this.$emit('mouseout'))
		},
		beforeDestroy() {
			this.marker.setMap(null)
			window.google.maps.event.clearInstanceListeners(this.marker)
		},
		render() {
			return null
		}
	}
</script>
<style scoped>

</style>
